import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "show-activities",
  class: "list-page d-flex flex-fill"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_11 = { class: "col d-flex" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "btn-label" }
const _hoisted_14 = { class: "btn-text" }
const _hoisted_15 = { class: "d-flex flex-row align-items-center justify-content-center" }
const _hoisted_16 = ["id"]
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-body d-flex flex-column" }
const _hoisted_19 = { class: "d-flex flex-row align-items-center" }
const _hoisted_20 = { class: "margin-top-3" }
const _hoisted_21 = {
  key: 0,
  class: "loader-25 margin-left-3"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "loader-25 margin-left-3"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "pagination-wrapper mt-1" }
const _hoisted_26 = { class: "loader-div-40" }
const _hoisted_27 = ["src"]

import {
  defineAsyncComponent,
  onMounted,
  onUnmounted,
  ref,
  watchEffect,
} from "vue";
import {
  ElButton,
  ElCard,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElInput,
  ElPopover,
  ElTable,
  ElTableColumn,
  ElTag,
  ElTooltip,
  ElDivider,
} from "element-plus";
import { TYPE } from "vue-toastification";
import {
  getFlowLogById,
  getFlowLogsFromElasticSearch,
  getAllFlowLogByActivityId,
  getFlowLogZipById,
  buildActivityLogLines,
} from "@/dashboard/services/flow_log.service";
import ProcessLogDialog from "@/dashboard/components/ProcessLogDialog.vue";
import {
  authInfo,
  hasPermission,
  updateMultiplePreference,
  updateSinglePreference,
} from "@/core/auth";
import { currentRoute, router } from "@/core/router";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";
import { getPreferenceValue } from "@/core/preferences/preferences";
import {
  connectWebsocket,
  getExchangeLog,
  getFilteredFlowList,
  getLatestLogs,
  isFailed,
  isRunning,
  isSkipped,
  restartFlow,
  stopFlow,
} from "@/flow/services/flow.service";
import i18n from "@/core/i18n/i18n";
import { showAlert } from "@/core/popup";
import { useDebouncedSearch } from "@/core/composables/useDebouncedSearch";
import { useLatestRequestGuard } from "@/core/composables/useLatestRequestGuard";
import OneTegPagination from "@/common/components/OneTegPagination.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Activities',
  props: {
    showClose: { type: Boolean }
  },
  emits: [
  "toggle-popup",
  "close",
  "downloadLogsAsText",
  "go-to-edit",
],
  setup(__props: any, { emit: __emit }) {

const ViewExchangeLog = defineAsyncComponent(
  () => import("@/activity/pages/ViewExchangeLog.vue")
);
const SimulateDialog = defineAsyncComponent(
  () => import("@/flow/components/SimulateDialog.vue")
);
const flowLogsRequestGuard = useLatestRequestGuard();
const totalElementsFlowLog = ref(0);
const totalPagesFlowLog = ref(0);
const currentPageFlowLog = ref(1);
const pageSizeFlowLog = ref(
  getPreferenceValue("pageSize") ? getPreferenceValue("pageSize") : 10
);
const searchFlowLogs = ref("");
const flowLogList = ref([]);
const loadingFlowLogs = ref(false);
const loadingProcessLogs = ref(false);
const buttonTrigger = ref(false);
const exchangeLogContent = ref("");
const flowValue = ref();
const processLogs = ref();
const processLogDialogVisible = ref(false);
const simulateDialogVisible = ref(false);
const selectedBuffer = ref([]);
const outputBuffer = ref([]);
const outputMap = ref<Map<any, any>>(new Map());
const selectedFlowId = ref();
const flowList = ref([]);
let client;
const statusClient = ref();
const flowName = ref("");
const sortField = ref(
  getPreferenceValue("activitiesSortField")
    ? getPreferenceValue("activitiesSortField")
    : "startedOn"
);

const sortAscending = ref(
  getPreferenceValue("activitiesSortOrder")
    ? getPreferenceValue("activitiesSortOrder")
    : "descending"
);

const flowsSortField = ref(
  getPreferenceValue("flowsSortField")
    ? getPreferenceValue("flowsSortField")
    : "createdAt"
);
const flowsSortOrder = ref(
  getPreferenceValue("flowsSortOrder")
    ? getPreferenceValue("flowsSortOrder")
    : "ascending"
);
const logBuffer = ref([]);

const flowId = ref(currentRoute.value.params.id as string);

const headerStyle = ref({
  color: "#363636",
  borderBottomColor: "#a9d4fa",
  fontSize: "13px",
  fontWeight: "bolder !important",
  backgroundColor: "#fbfbfb",
});

const rowStyle = ref({
  cursor: "pointer",
  backgroundColor: "#fbfbfb",
  fontSize: "13px",
});

const { t } = i18n.global;

const props = __props;

const emit = __emit;

onMounted(() => {
  getFlowLogs();
  if (authInfo.value) {
    connectWebsocket().then((stompClient) => {
      stompClient.debug = (f) => f;
      statusClient.value = stompClient;
      stompClient.connect({}, () => {
        stompClient.subscribe(
          `/organization/${authInfo.value.organizationId}/flow/status`,
          (val) => {
            const statusData = JSON.parse(val.body);
            const flow = flowList.value.find(
              (item) => item.id === statusData.flowId
            );
            if (flow) {
              flow.flowStatusType = statusData.status;
            }
          }
        );
      });
    });
  }
});

onUnmounted(() => {
  if (statusClient.value) {
    statusClient.value.disconnect();
  }
  if (client) {
    client.disconnect();
  }
});

function convertDate(dateStr) {
  const date = new Date(dateStr);

  if (Number.isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
}

function logRow(row) {
  if (row?.includes("\n")) {
    logBuffer.value.push(...row.split("\n"));
  } else {
    logBuffer.value.push(row);
  }
}

function goToFlowEditPage(row) {
  if (hasPermission("FLOWS.LIST.EDIT")) {
    router.push(`/flows/edit/${row.flowId}/${row.version}`);
  }
}

async function showOutput(flow) {
  flowValue.value = flow;
  logBuffer.value.splice(0);
  await getAllFlowLogByActivityId(flow.id).then((response) => {
    if (response) {
      // Renders step logs and flow-level error logs together, so an activity whose only payload is
      // an error (a run that failed or was skipped before any step ran) still opens with its reason
      // instead of leaving the click with no visible response.
      const flowProcessLog = buildActivityLogLines(
        response.flowLogDto.stepLogs,
        response.flowLogDto.errorLogs
      );
      outputBuffer.value.splice(0);
      if (flowProcessLog.length > 0) {
        flowProcessLog.forEach(logRow);
        processLogs.value = outputBuffer;
        processLogDialogVisible.value = true;
      }
    }
  });
}

async function downloadLogsAsText(flow) {
  if (!processLogs.value) {
    showAlert(TYPE.WARNING, t("Flow.ProcessLogDownloadError"));
    return;
  }
  const response = await getFlowLogZipById(flow.id);
  const blob = new Blob([response], { type: "application/zip" });
  const link = document.createElement("a");
  link.setAttribute("download", `${flow.flowName}-flow-logs.zip`);
  link.href = URL.createObjectURL(blob);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

async function elasticLogs(activityID) {
  connectWebsocket().then((stompClient) => {
    stompClient.debug = (f) => f;
    client = stompClient;
    stompClient.connect({}, () => {
      stompClient.subscribe(`/flow/activity/${activityID}/process`, (val) => {
        outputBuffer.value.push(val.body);
      });
    });
  });
}

function close() {
  buttonTrigger.value = false;
  emit("close");
}
function closeSimulateDialog() {
  simulateDialogVisible.value = false;
}

function sortChanged(sort) {
  sortField.value = sort.prop;
  sortAscending.value = sort.order;
  updateMultiplePreference({
    activitiesSortField: sort.prop,
    activitiesSortOrder: sort.order,
  });
  getFlowLogs();
}

const { onSearchInput } = useDebouncedSearch(getFlowLogs);

function goToEditPage(row) {
  if (hasPermission("FLOWS.LIST.EDIT")) {
    router.push({
      path: `/activities/${row.id}`,
      query: { flowId: row.flowId, version: row.version },
    });
  }
}
function handleRowClick(row, column) {
  if (
    column.property !== "flowName" &&
    !row.flowDeleted &&
    !isSkipped(row.status)
  ) {
    goToEditPage(row);
  }
}

function rowClassName({ row }) {
  return isSkipped(row.status)
    ? "oneTeg-table-row-no-permission"
    : "oneTeg-table-row-permission";
}

function sizeChanged(val) {
  pageSizeFlowLog.value = val;
  updateSinglePreference("pageSize", val);
  getFlowLogs();
}

async function getFlowLogs() {
  const requestToken = flowLogsRequestGuard.start();
  loadingFlowLogs.value = true;
  const params = {
    organizationId: authInfo.value.organizationId,
    startDate: null,
    search: searchFlowLogs.value,
    flowStatusTypeList: null,
    pageNumber: currentPageFlowLog.value - 1,
    pageSize: pageSizeFlowLog.value,
    sortField: sortField.value,
    ascending: sortAscending.value === "ascending",
  };
  try {
    const page = flowId.value
      ? await getFlowLogById(flowId.value, params)
      : await getFlowLogsFromElasticSearch(params);
    // OT-4928: discard a stale response superseded by a newer search/request.
    if (!flowLogsRequestGuard.isLatest(requestToken)) {
      return;
    }
    if (page) {
      flowLogList.value = flowId.value
        ? page.content.map((item) => item.flowLogDto)
        : page.data.map((item) => item.flowLogDto);
      totalElementsFlowLog.value = page.totalElements;
      totalPagesFlowLog.value = page.totalPages;
    }
    const flowParams = {
      pageNumber: currentPageFlowLog.value - 1,
      pageSize: pageSizeFlowLog.value,
      sortField: flowsSortField.value,
      ascending: flowsSortOrder.value === "ascending",
      search: searchFlowLogs.value,
    };
    const flowPage = await getFilteredFlowList(flowParams);
    if (!flowLogsRequestGuard.isLatest(requestToken)) {
      return;
    }
    flowList.value = flowPage.data;
  } finally {
    // OT-4928: only the newest request owns the spinner — a superseded one must
    // not clear it, and a newest one that fails must not leave it stuck on.
    if (flowLogsRequestGuard.isLatest(requestToken)) {
      loadingFlowLogs.value = false;
    }
  }
}

function closeProcessLogDialog() {
  processLogDialogVisible.value = false;
}

function stopSelectedFlow(activityId) {
  if (hasPermission("FLOWS.LIST.STOP")) {
    stopFlow(activityId).catch(() => {
      showAlert(TYPE.ERROR, "An error occurred while stopping the flow.");
    });
  }
}

function startSelectedFlow(activityId, flowID, flowName1) {
  if (hasPermission("FLOWS.LIST.RUN")) {
    loadingProcessLogs.value = true;
    flowName.value = "";
    simulateDialogVisible.value = false;
    flowName.value = flowName1;
    outputBuffer.value = [];
    outputMap.value.clear();
    selectedFlowId.value = flowID;
    restartFlow(activityId)
      .then(() => {
        simulateDialogVisible.value = true;
        readFlowProcess(flowID, true);
      })
      .catch(() => {
        showAlert(TYPE.ERROR, "An error occurred while starting the flow.");
      })
      .finally(() => {
        loadingProcessLogs.value = false;
      });
  }
}
function logProcessLog(row) {
  outputBuffer.value.push(row);
}
async function readFlowProcess(flowID, init) {
  if (outputMap.value.has(flowID)) {
    outputBuffer.value = outputMap.value.get(flowID);
  } else if (!init) {
    const latest = await getLatestLogs(flowID);
    if (latest) {
      outputBuffer.value.splice(0);
      const logRowArray = latest.processLog.log.split("\n");
      logRowArray.forEach(logProcessLog);
    } else {
      outputBuffer.value = [];
    }
  } else {
    outputBuffer.value = [];
  }

  outputMap.value.set(flowID, outputBuffer.value);
  if (client) {
    client.disconnect();
    client = undefined;
  }

  connectWebsocket().then((stompClient) => {
    stompClient.debug = (f) => f;
    client = stompClient;
    stompClient.connect({}, () => {
      stompClient.subscribe(`/flow/${flowID}/process`, (val) => {
        outputBuffer.value.push(val.body);
      });
    });
  });
}

watchEffect(() => {
  selectedBuffer.value = outputMap.value.get(selectedFlowId.value);
});

async function showExchangeLog(activityId) {
  buttonTrigger.value = false;
  exchangeLogContent.value = "";
  const exchange = await getExchangeLog(activityId);
  exchangeLogContent.value = exchange;
  buttonTrigger.value = true;
  emit("toggle-popup");
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ElCard), { class: "card border-0 oneTeg-card oneTeg-card-body" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTable), {
            data: flowLogList.value,
            "default-sort": { prop: sortField.value, order: sortAscending.value },
            class: "oneTeg-table oneTeg-table--sm",
            "row-class-name": rowClassName,
            "empty-text": loadingFlowLogs.value ? ' ' : 'No Data',
            onSortChange: sortChanged,
            onRowClick: handleRowClick,
            height: "97%"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElTableColumn), {
                prop: "id",
                label: _unref(t)('Common.ActivityId'),
                width: "auto"
              }, null, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                prop: "flowName",
                label: _unref(t)('Common.FlowName'),
                sortable: "custom",
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_unref(ElTooltip), {
                    content: scope.row.flowId,
                    placement: "right",
                    effect: "custom"
                  }, {
                    default: _withCtx(() => [
                      (!scope.row.flowDeleted)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: _withModifiers(($event: any) => (goToFlowEditPage(scope.row)), ["stop"]),
                            class: "cursor-pointer color-blue"
                          }, [
                            _createTextVNode(_toDisplayString(scope.row.flowName) + " ", 1),
                            (scope.row.version != null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(v." + _toDisplayString(scope.row.version) + ")", 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_2))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                            _createTextVNode(_toDisplayString(scope.row.flowName) + " ", 1),
                            _hoisted_5,
                            _createElementVNode("span", null, "(" + _toDisplayString(_unref(t)("Common.Deleted")) + ")", 1)
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["content"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                prop: "status",
                label: _unref(t)('Common.Status'),
                sortable: "custom",
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.status === 'TRIGGERED')
                    ? (_openBlock(), _createBlock(_unref(ElTag), {
                        key: 0,
                        type: "info"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.status), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (scope.row.status === 'STARTING')
                      ? (_openBlock(), _createBlock(_unref(ElTag), {
                          key: 1,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.status), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (
                ['FAILED', 'ABORTED', 'TERMINATED'].includes(scope.row.status)
              )
                        ? (_openBlock(), _createBlock(_unref(ElTag), {
                            key: 2,
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.status), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (scope.row.status === 'FLOW_DELETED')
                          ? (_openBlock(), _createBlock(_unref(ElTag), {
                              key: 3,
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString("FLOW DELETED"))
                              ]),
                              _: 1
                            }))
                          : (scope.row.status === 'COMPLETED')
                            ? (_openBlock(), _createBlock(_unref(ElTag), {
                                key: 4,
                                type: "success"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.status), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : (scope.row.status === 'WARNING')
                              ? (_openBlock(), _createBlock(_unref(ElTag), {
                                  key: 5,
                                  type: "warning"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row.status), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : (scope.row.status === 'SKIPPED')
                                ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                    key: 6,
                                    effect: "custom",
                                    content: _unref(t)('Schedule.SkippedTooltip'),
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElTag), { type: "info" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.row.status), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["content"]))
                                : (_openBlock(), _createBlock(_unref(ElTag), { key: 7 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(scope.row.status === "INPROGRESS"
                ? "IN PROGRESS"
                : scope.row.status), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                prop: "triggeredOn",
                sortable: "custom",
                label: _unref(t)('Common.TriggeredTime'),
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.triggeredOn != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(convertDate(scope.row.triggeredOn)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                prop: "startedOn",
                sortable: "custom",
                label: _unref(t)('Common.StartedTime'),
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.startedOn != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(convertDate(scope.row.startedOn)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                prop: "finishedOn",
                label: _unref(t)('Common.FinishedTime'),
                sortable: "custom",
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.finishedOn != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(convertDate(scope.row.finishedOn)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                prop: "executionType",
                label: _unref(t)('Common.ExecutionType'),
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.executionType), 1),
                  (scope.row.executionEnvironment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(scope?.row?.executionEnvironment), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                label: _unref(t)('Common.Actions'),
                width: "300px"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_unref(ElInput), {
                      modelValue: searchFlowLogs.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchFlowLogs).value = $event)),
                      size: "mini",
                      id: "activities-search",
                      class: "oneTeg-search-input max-w-170",
                      onInput: _unref(onSearchInput),
                      placeholder: _unref(t)('Common.TypeToSearch')
                    }, null, 8, ["modelValue", "onInput", "placeholder"]),
                    _createVNode(_unref(ElDivider), {
                      direction: "vertical",
                      class: "v-divider-stretch",
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(ElButton), {
                        disabled: loadingFlowLogs.value,
                        id: "refresh-button",
                        onClick: getFlowLogs,
                        class: "no-border btn-oneTeg-table-create btn-labeled",
                        size: "mini",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, [
                              _createVNode(_component_font_awesome_icon, { icon: "redo-alt" })
                            ]),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("Common.Refresh")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      (_ctx.showClose)
                        ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                            key: 0,
                            effect: "custom",
                            content: _unref(t)('Common.Close'),
                            placement: "bottom"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ElButton), {
                                class: "no-border btn-link-icon",
                                size: "mini",
                                type: "primary",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('go-to-edit'))),
                                "data-test": "activities-close-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "times" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["content"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_15, [
                    (!_unref(isSkipped)(scope.row.status))
                      ? (_openBlock(), _createBlock(_unref(ElDropdown), { key: 0 }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_unref(ElDropdownMenu), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElDropdownItem), {
                                  id: 'flow-logs-button-' + scope.$index,
                                  onClick: _withModifiers(($event: any) => (showOutput(scope.row)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)("Flow.FlowLogs")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["id", "onClick"]),
                                (
                        _unref(hasPermission)('FLOWS.LIST.STOP') &&
                        _unref(isRunning)(scope.row.status)
                      )
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 0,
                                      id: 'stop-button-' + scope.$index,
                                      onClick: _withModifiers(($event: any) => (stopSelectedFlow(scope.row.activityId)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Flow.Stop")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "onClick"]))
                                  : _createCommentVNode("", true),
                                (
                        _unref(hasPermission)('FLOWS.LIST.RUN') &&
                        _unref(isFailed)(scope.row.status)
                      )
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 1,
                                      id: 'start-button-' + scope.$index,
                                      onClick: _withModifiers(($event: any) => (
                        startSelectedFlow(
                          scope.row.id,
                          scope.row.flowId,
                          scope.row.flowName
                        )
                      ), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Flow.Re-run")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_unref(ElDropdownItem), null, {
                                  default: _withCtx(() => [
                                    (scope.row.splitIx || scope.row.splitSize)
                                      ? (_openBlock(), _createBlock(_unref(ElPopover), {
                                          key: 0,
                                          placement: "left",
                                          width: 400,
                                          trigger: "hover"
                                        }, {
                                          reference: _withCtx(() => [
                                            _createElementVNode("div", {
                                              id: 'inline-edit-back-' + scope.$index
                                            }, _toDisplayString(_unref(t)("Common.LoopStatus")), 9, _hoisted_16)
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_17, [
                                              _createElementVNode("div", _hoisted_18, [
                                                _createElementVNode("label", null, _toDisplayString(scope.row.status === "FAILED"
                                  ? _unref(t)("Common.LoopFailedIx")
                                  : _unref(t)("Common.LoopIx")) + " : " + _toDisplayString(scope.row.splitIx !== undefined
                                  ? scope.row.splitIx
                                  : "-"), 1),
                                                _createElementVNode("label", null, _toDisplayString(_unref(t)("Common.LoopSize")) + " : " + _toDisplayString(scope.row.splitSize || "-"), 1),
                                                _createElementVNode("div", _hoisted_19, [
                                                  _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(t)("Common.LoopStatus")) + " : " + _toDisplayString(scope.row.status) + "  ", 1),
                                                  (_unref(isRunning)(scope.row.status))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                        _createElementVNode("img", {
                                                          src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                                                          alt: "Loading...",
                                                          class: "loader-logo-25"
                                                        }, null, 8, _hoisted_22)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              class: "no-border btn-oneTeg show-on-row-hover",
                              size: "mini",
                              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                              id: 'cog-button-' + scope.$index,
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "cog" })
                              ]),
                              _: 2
                            }, 1032, ["id"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (scope.row.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("img", {
                            src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                            alt: "Loading...",
                            class: "loader-logo-25"
                          }, null, 8, _hoisted_24)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data", "default-sort", "empty-text"]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(OneTegPagination, {
              "page-sizes": [10, 25, 50, 100],
              "page-size": pageSizeFlowLog.value,
              "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageSizeFlowLog).value = $event)),
              total: totalElementsFlowLog.value,
              "current-page": currentPageFlowLog.value,
              "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((currentPageFlowLog).value = $event)),
              background: true,
              small: true,
              onSizeChange: sizeChanged,
              onCurrentChange: getFlowLogs,
              layout: 'total, sizes, prev, pager, next'
            }, null, 8, ["page-size", "total", "current-page"])
          ])
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_26, [
        _createElementVNode("img", {
          src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
          alt: "Loading...",
          class: "loader-logo-40"
        }, null, 8, _hoisted_27)
      ], 512), [
        [_vShow, loadingFlowLogs.value]
      ])
    ]),
    (buttonTrigger.value)
      ? (_openBlock(), _createBlock(_unref(ViewExchangeLog), {
          key: 0,
          dialog: buttonTrigger.value,
          moved: false,
          stoppable: false,
          exchangeLogContent: exchangeLogContent.value,
          onClose: close
        }, null, 8, ["dialog", "exchangeLogContent"]))
      : _createCommentVNode("", true),
    _createVNode(ProcessLogDialog, {
      dialog: processLogDialogVisible.value,
      logBuffer: logBuffer.value,
      moved: false,
      flowName: flowValue.value?.flowName,
      flowVersion: flowValue.value?.version,
      onClose: closeProcessLogDialog,
      onDownloadLogsAsText: _cache[5] || (_cache[5] = ($event: any) => (downloadLogsAsText(flowValue.value)))
    }, null, 8, ["dialog", "logBuffer", "flowName", "flowVersion"]),
    (simulateDialogVisible.value)
      ? (_openBlock(), _createBlock(_unref(SimulateDialog), {
          key: 1,
          dialog: simulateDialogVisible.value,
          selectedBuffer: selectedBuffer.value,
          flowName: flowName.value,
          moved: false,
          stoppable: false,
          onClose: closeSimulateDialog
        }, null, 8, ["dialog", "selectedBuffer", "flowName"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})